import styled from 'styled-components';   
 export const NavWrapper = styled.div
 `
 background-color: #fdb73b;
 padding-bottom:20px;
 form{
     background:#fff;
     margin-left:30px;
     height: 40px;
     padding: 0 20px;
     border-radius: 100px;
     
 }
  input{
      border:none;
      padding: 2px;
      width:200px;
      padding:10px;
  }
  input: focus{
      box-shadow:none;
      border:none;
  }
 
`;

